module.exports = __webpack_public_path__ + "img/flood_sensor_color.e5c77c1d.svg";